var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 21.3636C14.3389 20.971 14.1074 20.5026 14 20C14 19.2857 16.8889 15.7143 20.5 15.7143M25.9889 18.4286C26.4587 18.8562 26.8073 19.3979 27 20C27 20.7143 24.8333 24.2857 20.5 24.2857C20.2732 24.2857 20.0522 24.2757 19.837 24.2571M15.4444 25L25.5556 15M22.6667 20C22.6667 20.5683 22.4384 21.1134 22.0321 21.5152C21.6257 21.9171 21.0746 22.1429 20.5 22.1429C19.9254 22.1429 19.3743 21.9171 18.9679 21.5152C18.5616 21.1134 18.3333 20.5683 18.3333 20C18.3333 19.4317 18.5616 18.8866 18.9679 18.4848C19.3743 18.0829 19.9254 17.8571 20.5 17.8571C21.0746 17.8571 21.6257 18.0829 22.0321 18.4848C22.4384 18.8866 22.6667 19.4317 22.6667 20Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/eye_close_icon.30e08ac13620332ab8c8630477810f0f.svg";
export { ForwardRef as ReactComponent };